// The admin menu comes from the backend (UMNG) already filtered by the company's modules and the admin's permissions.
// A route marked `meta: { menuGated: true }` opens only when the menu has its node, so its URL alone does not open it.

/**
 * Whether the menu tree has a node for this route name (side-menu.vue links nodes by `route`).
 * @param {object} node a menu node; the root's nodes are under `children`
 * @param {string} routeName
 * @returns {boolean}
 */
export function isRouteInMenu(node, routeName) {
  if (!node || typeof node !== 'object' || !routeName) return false;
  if (node.route === routeName) return true;
  return (node.children || []).some((child) => isRouteInMenu(child, routeName));
}

/**
 * Whether the menu has loaded: the store starts it as [], and it stays so when the menu call fails.
 * @param {object|Array} menu store.state.mainMenu
 * @returns {boolean}
 */
export function isMenuLoaded(menu) {
  return !!menu && typeof menu === 'object' && !Array.isArray(menu);
}

/**
 * Whether the shell may show a route: true, false (the no-access message), or null while the shell still loads the
 * menu. A menu that failed to load lets the route open, as before.
 * @param {object} route the current route (`name`, `meta`)
 * @param {object|Array} menu store.state.mainMenu
 * @param {boolean} shellLoaded the shell has finished loading the user, the settings and the menu
 * @returns {boolean|null}
 */
export function routeAccessOf(route, menu, shellLoaded) {
  if (!route?.meta?.menuGated) return true;
  if (!shellLoaded) return null;
  if (!isMenuLoaded(menu)) return true;
  return isRouteInMenu(menu, route.name);
}
